import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import ServiceItem from '../ServiceItem'
import ProductItem from '../ProductItem'
import { PromotionsAndSummary } from 'src/components/ShoppingQuote'

const QuotedItemsAndServicesList = ({
  className,
  isDetailsAreExpanded,
  services,
  products,
  freeAligmentTooltip,
  appliedPromotions,
  quoteSummary,
  storePhoneNumber,
  formattedStorePhoneNumber
}) =>
  <List
    isDetailsAreExpanded={ isDetailsAreExpanded }
    className={ className }>
    {(services && services.length) && (
      services.map(service => (
        <ServiceItem
          key={ service.commerceItemId }
          storePhoneNumber={ storePhoneNumber }
          formattedStorePhoneNumber={ formattedStorePhoneNumber }
          service={ service } />
      ))
    )}

    {(Boolean(products) && Boolean(products.length)) && (
      <>
        {products.map(product => (
          <ProductItem
            key={ product.commerceItemId }
            services={ services }
            storePhoneNumber={ storePhoneNumber }
            formattedStorePhoneNumber={ formattedStorePhoneNumber }
            freeAligmentTooltip={ freeAligmentTooltip }
            product={ product } />
        ))}
        <ProductsAndServicesSummary
          noEdit
          appliedPromotions={ appliedPromotions || [] }
          quoteSummary={ quoteSummary } />
      </>
    )}
  </List>

QuotedItemsAndServicesList.propTypes = {
  appliedPromotions: PropTypes.shape(),
  className: PropTypes.string,
  formattedStorePhoneNumber: PropTypes.string,
  freeAligmentTooltip: PropTypes.shape(),
  isDetailsAreExpanded: PropTypes.bool,
  products: PropTypes.arrayOf(PropTypes.shape()),
  quoteSummary: PropTypes.shape(),
  services: PropTypes.arrayOf(PropTypes.shape()),
  storePhoneNumber: PropTypes.string
}

export default QuotedItemsAndServicesList

const List = styled.ul`
  padding: 0;

  & li:not(:first-child) {
    border-top: 1px solid #000;
  }

  & li:last-child {
    padding-top: 20px;
  }
`

const ProductsAndServicesSummary = styled(PromotionsAndSummary)`
  padding: 20px 0 0;

  > div {
    width: 100%;
    float: none;

    @media (max-width: 1023px) {
      margin: 0;
    }
  }
`
